/**
 *
 * @Info
 * As a rule of thumb we name the exported mutation
 * in CamelCaseCaps and the actual mutation value in camelCase.
 */

// GLOBAL
export const ResetStore = 'resetStore';

// AMP STORE MUTATIONS
// General
export const SetCurrentAmpData = 'setCurrentAmpData';
export const SetAmps = 'setAmps';
export const SetDnsStatus = 'setDnsStatus';
export const SetLoadingDns = 'setLoadingDns';
export const SetDnsRecords = 'setDnsRecords';
export const SetInitialDnsLoad = 'setInitialDnsLoad';
export const AddAmpToRecentlyViewed = 'addAmpToRecentlyViewed';
export const ChangeCreateAmpDto = 'changeCreateAmpDto';
export const DeleteAmpById = 'deleteAmpById';
export const ResetStepper = 'resetStepper';
export const SetLiveAmps = 'setLiveAmps';
export const SetAmpStep = 'setAmpStep';
export const SetCreateAmpDto = 'setCreateAmpDto';
export const SetCreateAmpErr = 'setCreateAmpErr';
export const SetCurrentAmp = 'setCurrentAmp';
export const SetFavoriteAmps = 'setFavoriteAmps';
export const SetCenterOnNode = 'setCenterOnNode';
export const SetAmpSortOrder = 'setAmpSortOrder';
export const SetSearchedAmps = 'setSearchedAmps';
export const UpdateAmpDomain = 'updateAmpDomain';
export const SetTemplates = 'setTemplates';
export const SetDraftAmps = 'setDraftAmps';
export const SetNodesClipboard = 'setNodesClipboard';

// AUTH
export const SetSubscriptions = 'setSubscriptions';

// Changeset
export const SetChangeset = 'setChangeset';
export const EmptyChangeSet = 'emptyChangeSet';
export const SetApplyingChangesetState = 'setApplyingChangesetState';

// Conversation
export const SetConversationInputFocused = 'setConversationINputFocused';
export const SetSelectedConversationId = 'setSelectedConversationId';
export const ToggleDeleteConversationPopup = 'toggleDeleteConversationPopup';
export const SetDeletedConversationId = 'setDeletedConversationId';
export const DeleteConversations = 'deleteConversations';
export const UpdateAmpData = 'updateAmpData';

// Node
export const AddNode = 'addNode';
export const BatchUpdateNodeData = 'batchUpdateNodeData';
export const UpdateNodeData = 'updateNodeData';
export const BatchDeleteNodes = 'batchDeleteNodes';

// BUILDER STORE MUTATIONS
export const DecrementUndoHead = 'decrementUndoHead';
export const IncrementUndoHead = 'incrementUndoHead';
export const ResetChangesetState = 'resetChangesetState';
export const SetAddingNode = 'setAddingNode';
export const SetSelectedNodeId = 'setSelectedNodeId';
export const SetSelectedSubNode = 'setSelectedSubNode';
export const SetZoom = 'setZoom';
export const ToggleDragging = 'toggleDragging';
export const UpdateUndoStack = 'updateUndoStack';
export const SetHighlightedNode = 'setHighlightedNode';
export const ForceRebuild = 'forceRebuild';

// AUTH STORE MUTATIONS
export const ChangeSignUpPassword = 'changeSignUpPassword';
export const ChangeConfirmSignUpPassword = 'changeSignUpPassword';
export const ChangePasswordRules = 'changePasswordRules';
export const ChangeEmail = 'changeForgotPasswordEmail';
export const SetUserData = 'setUserData';
export const SetActiveOrganization = 'setActiveOrganization';
export const SetOrgEnsuredState = 'setOrgEnsuredState';
export const SetLastOrganizationId = 'setLastOrganizationId';
export const SetPlanInfo = 'setPlanInfo';

// POPUP STORE MUTATIONS
export const ToggleConfigureMenuPopup = 'toggleConfigureMenuPopup';
export const ToggleMediaUploadPopup = 'toggleMediaUploadPopup';
export const ToggleMultiDeletePopup = 'toggleMultiDeletePopup';
export const ToggleSettingsPopup = 'toggleSettingsPopup';
export const SaveSelectedNode = 'saveSelectedNode';
export const UpdateSelectedNode = 'updateSelectedNode';
export const RemoveSelectedNode = 'removeSelectedNode';
export const SetNodesForDeletion = 'setNodesForDeletion';

// SIDE PANEL MUTATIONS
export const ToggleTriggersPanel = 'toggleTriggerPanel';
export const ToggleNewTriggerForm = 'toggleNewTriggerForm';
export const SetSidepanelTriggered = 'setSidepanelTriggered';
export const SetOpenedConversation = 'setOpenedConversation';
export const SetShowSlidesPanel = 'setShowSlidesPanel';

// ADMINISTRATION MUTATIONS
export const SetMembers = 'setMembers';
export const SetRoles = 'setRoles';

// PREVIEW MUTATIONS
export const SetCurrentNode = 'setCurrentNode';
export const SetPreviewRunning = 'setPreviewRunning';

// PLUGIN MUTATIONS
export const SetPlugins = 'setPlugins';

// REALTIME MUTATIONS
export const AddRealtimeListener = 'addRealtimeListener';
export const ClearRealtimeListener = 'clearRealtimeListener';

// WIZARD
export const IncrementCurrentStep = 'incrementCurrentStep';
export const DecrementCurrentStep = 'decrementCurrentStep';
export const SetTotalSteps = 'setTotalSteps';
export const SetFileToUpload = 'setFileToUpload';
export const SetShowUploadPopup = 'setShowUploadPopup';
export const SetCurrentStep = 'setCurrentStep';
export const SetUploadProgress = 'setUploadProgress';
export const SetUploadStep = 'setUploadStep';
export const ResetWizzard = 'resetWizzard';
export const SetWizzardError = 'setWizazrdError';
export const SetReimportStarted = 'setReimportStarted';
export const SetShowImportSlides = 'setShowImportSlides';
export const SetLoadingSlides = 'setLoadingSlides';
export const PushSlides = 'pushSlides';
export const ClearSlides = 'clearSlides';

// NOTIFICATIONS
export const AddToastNotification = 'addToastNoticication';
export const RemoveToastNotification = 'removeToastNotification';
export const ShowToast = 'showToast';
export const AddNotification = 'addNotification';
export const RemoveNotificationById = 'removeNotificationById';
export const RemoveAllNotifications = 'removeAllNotifications';
export const ReadNotificationsById = 'readNotificationsById';
export const ReadAllNotifications = 'readAllNotifications';

// INSIGHTS
export const SetSessionInsights = 'setAmpInsights';
export const SetInsightsLoading = 'setInsightsLoading';
export const SetSelectedDomain = 'setSelectedDomain';
export const SetSelectedTimeRange = 'setSelectedTimeRange';
export const SetSelectedVersion = 'setSelectedVersion';
export const SetCustomRange = 'setCustomRange';
export const SetLoadingInsightsAllDataJson = 'setLoadingInsightsAllDataJson';
export const SetLoadingInsightsJson = 'setLoadingInsightsJson';
export const SetLoadingInsightsPdf = 'setLoadingInsightsPdf';
export const SetShowInsightsToggleUI = 'setShowInsightsToggleUI';
export const SetInsightsSectionsCounts = 'setInsightsSectionsCounts';
export const ResetInsights = 'resetInsights';

// CRM
export const SetCrmConnector = 'setCrmConnector';
export const SetCrmEditMode = 'setCrmEditMode';
export const SetCrmDto = 'setCrmDto';
export const SetCrmConnectorType = 'setCrmConnectorType';
export const SetAccountKeys = 'setAccountKeys';
export const SetIsInitialSave = 'setIsInitialSave';
export const SetKeysLoading = 'setKeysLoading';
export const SetCrmLoading = 'setCrmLoading';
export const SetSelectedKeys = 'setSelectedKeys';
export const SetEditSettings = 'setEditSettings';
